<div class="flex-row flex-fill">
    <mat-tab-group
        class="flex"
        mat-stretch-tabs="false"
        [selectedIndex]="selectedTabIndex"
        [cbTabRoute]="PROJECT_ROUTE"
    >
        <mat-tab label="Details" cbTabRouteId="details">
            <form #leadEditForm="ngForm">
                <cb-manage-project-details
                    *cbWaitFor="mappedItem$$ | async"
                    [mappedItem]="mappedItem"
                >
                </cb-manage-project-details>
            </form>
        </mat-tab>
        <mat-tab label="Release Stages" cbTabRouteId="release-stages">
            <ng-template matTabContent>
                <cb-project-releases-list
                    *cbWaitFor="mappedItem$$ | async"
                    [mappedItem]="mappedItem"
                >
                </cb-project-releases-list>
            </ng-template>
        </mat-tab>
        @if (canViewNotes()) {
            <mat-tab label="Notes" cbTabRouteId="notes">
                <ng-template matTabContent>
                    <cb-notes
                        *cbWaitFor="mappedItem$$ | async"
                        [entity]="mappedItem"
                        [edit]="true"
                        [permissions]="notePermissions"
                    >
                    </cb-notes>
                </ng-template>
            </mat-tab>
        }
        @if (canViewDocuments()) {
            <mat-tab label="Documents" cbTabRouteId="documents">
                <ng-template matTabContent>
                    <cb-document
                        *cbWaitFor="mappedItem$$ | async"
                        [entity]="mappedItem"
                        [permissions]="documentPermissions"
                        [includeLinked]="true"
                        [systemArea]="systemArea"
                        [showPdfButton]="true"
                    >
                    </cb-document>
                </ng-template>
            </mat-tab>
        }
        @if (canViewHistory()) {
            <mat-tab label="History" cbTabRouteId="history">
                <ng-template matTabContent>
                    <cb-history-list
                        *cbWaitFor="mappedItem$$ | async"
                        [entityId]="mappedItem?.id"
                        [entity]="HISTORY_SEARCH_ENTITY.Project"
                    >
                    </cb-history-list>
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
    @if (mappedItem) {
        <cb-manage-project-side-bar-card
            [mappedItem]="mappedItem"
            class="cb-margin"
            (projectUpdated)="reloadMappedItem()"
        >
        </cb-manage-project-side-bar-card>
    }
</div>
